<template>
  <div class="fgys">
    <sub-title text="解决方案3大优势" />
    <div class="list">
      <div class="item flex_start">
        <div class="cove">
          <img src="../../../assets/jpcol/jjfays1.png" alt="" />
        </div>
        <div class="wz">
          <div class="wz1">语言简洁易理解</div>
          <div class="wz2">语言简单明了，直击重点，可读性强</div>
        </div>
      </div>
      <div class="item flex_start">
        <div class="cove">
          <img src="../../../assets/jpcol/jjfays2.png" alt="" />
        </div>
        <div class="wz">
          <div class="wz1">脉络清晰易查找</div>
          <div class="wz2">方案结构清晰，问题查找更便捷</div>
        </div>
      </div>
      <div class="item flex_start">
        <div class="cove">
          <img src="../../../assets/jpcol/jjfays3.png" alt="" />
        </div>
        <div class="wz">
          <div class="wz1">图解流程更直观</div>
          <div class="wz2">流程图呈现解决步骤，可视化强</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.fgys {
  width: 100%;
  height: 100%;
  padding: 24px 20px;

  .list {
    padding-top: 4px;
    .item {
      margin-top: 26px;
      .cove {
        img {
          width: 54px;
          height: 54px;
          border-radius: 50%;
        }
      }
      .wz {
        margin-left: 18px;
        .wz1 {
          font-size: 16px;
          color: #333333;
          line-height: 16px;
        }
        .wz2 {
          margin-top: 10px;
          font-size: 12px;
          color: #666666;
          line-height: 12px;
        }
      }
    }
  }
}
</style>